<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { sumBy } from 'lodash-es';
import Download from '../PaymentsDownload';
import Overlay from '../../TwOverlay';

export default {
  name: 'PaymentTable',
  components: {
    Download,
    Overlay,
  },
  computed: {
    ...mapState({
      rows: state => state.supplierPayments.tableData.rows,
      loading: state => state.supplierPayments.tableData.loading,
      loaded: state => state.supplierPayments.tableData.loaded,
      error: state => state.supplierPayments.tableData.error,
      downloadListLoading: state => state.supplierPayments.download.list.loading,
      downloadListError: state => state.supplierPayments.download.list.error,
      downloadSpecLoading: state => state.supplierPayments.download.specifications.loading,
      downloadSpecError: state => state.supplierPayments.download.specifications.error,
      downloadSpecName: state => state.supplierPayments.download.specifications.name,
    }),
    ...mapGetters({
      headers: 'supplierPayments/getSupplierPaymentsPaymentTableHeaders',
      downloadInfo: 'supplierPayments/getDownloadSearchInfo',
    }),
    totalAmountPaid() {
      return sumBy(this.rows, 'paidInEuro');
    },
    downloadDisabled() {
      return this.loading ||
        this.error ||
        !this.rows ||
        !this.rows.length ||
        this.downloadListLoading ||
        this.downloadSpecLoading;
    },
  },
  methods: {
    ...mapActions({
      downloadList: 'supplierPayments/downloadList',
      downloadSpecifications: 'supplierPayments/downloadSpecifications',
    }),
    downloadPayments(payment) {
      if (this.downloadDisabled) {
        return;
      }
      this.downloadSpecifications(payment);
    },
  },
  filters: {
    formatNumber: number => parseFloat(number).toFixed(2)
      .replace(/\./, ',')
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  },
  data() {
    return {
      rowsPerPageItems: [5, 10, 25, 50, 100, { text: this.$t('inputs.all'), value: -1 }],
      pagination: {
        rowsPerPage: 25,
      },
    };
  },
};
</script>

<template>
  <v-flex class="payment-table xs12 mt-4">
    <h1 class="my-1 text-xs-center">{{ $t('supplierPayments.lists.titles.payments') }}</h1>
    <download
      @download="downloadList"
      :disabled="downloadDisabled"
      :loading="downloadListLoading"
      :error="downloadListError"
      :error-message="$t('payments.actions.downloadError')"
      :info="downloadInfo"
    />
    <v-divider />
    <v-flex class="payment-table__table xs12">
      <overlay :visible="downloadSpecLoading"/>
      <v-data-table
        :headers="headers"
        :items="rows"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">
          <tr class="payment-table__table-row" @click="downloadPayments(props.item)">
            <td class="text-xs-center">{{ props.item.createdAt }}</td>
            <td class="text-xs-center">{{ props.item.id }}</td>
            <td>{{ props.item.product.name }}</td>
            <td>{{ props.item.supplier.name }}</td>
            <td class="text-xs-right">{{ props.item.paid | formatNumber }}</td>
            <td class="text-xs-center">{{ props.item.currency }}</td>
            <td class="text-xs-right">{{ props.item.paidInEuro | formatNumber }}</td>
          </tr>
        </template>
        <template slot="footer">
          <tr v-if="rows.length">
            <td :colspan="header.length" class="text--grey caption">
              {{ $t('payments.actions.downloadPayment') }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div v-if="error">
            <v-alert :value="true" icon="warning">
              {{ $t('payments.actions.error') }}.
              <span class="payment-table__text-link" @click="$emit('refresh')">
                  {{ $t('inputs.misc.tryAgain') }}
                </span>
            </v-alert>
          </div>
          <div v-else-if="loading">
            <!--Show nothing when loading-->
          </div>
          <div class="text-xs-center" v-else-if="!loaded">
            <span>{{ $t('payments.actions.performSearch') }}</span>
          </div>
          <div class="text-xs-center" v-else>
            <span>{{ $t('inputs.misc.noContent') }}</span>
          </div>
        </template>
      </v-data-table>
    </v-flex>
    <v-snackbar
      :value="downloadSpecName"
      :timeout="0"
      bottom
    >
      <v-progress-circular
        color="primary"
        size="15"
        width="2"
        indeterminate
      />
      <span class="ml-3">
        {{ $t('payments.actions.downloadSpecLoading', { name: `#${downloadSpecName}` }) }}
      </span>
    </v-snackbar>
    <v-snackbar
      :value="downloadSpecError"
      bottom
    >
      {{ $t('payments.actions.downloadSpecError') }}
    </v-snackbar>
  </v-flex>
</template>

<style lang="scss">
  .payment-table {
    position: relative;

    &__table {
      position: relative;
    }

    &__text-underline {
      text-decoration: underline;
    }

    &__text-link {
      text-decoration: underline;
      cursor: pointer;
    }

    &__table-row > td:not(:first-child) {
      border-left: 1px solid black;
    }

    &__table-row {
      cursor: pointer;
    }

    &__table-row:nth-child(even) {
      background-color: #f5f5f5
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payments/supplier-payments/SupplierPaymentsPaymentTable.vue